import { ArnCondition, ArnPredefinedConditionTemplate } from './ArnCondition';
import { ArnConditionOpts } from './ArnConditionOpts';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface HasERC721ConditionOpts extends ArnConditionOpts {}

export interface HasERC721ConditionDetailedOpts extends HasERC721ConditionOpts {
  chainId: number;
  contractAddress: string;
  minBalance?: number;
  tokenId?: number;
}

export class HasERC721Condition<
  T extends HasERC721ConditionOpts = HasERC721ConditionOpts
> implements ArnCondition
{
  readonly templateName = ArnPredefinedConditionTemplate.HasERC721;

  constructor(public opts: T) {}
}
